import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const DeleteUploadedFile = createAsyncThunk(
    "deleteFile", async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.deleteUploadedFile, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const DeleteUploadedFileSlice = createSlice({
    name: "deleteFile",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        deleteFileReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [DeleteUploadedFile.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [DeleteUploadedFile.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [DeleteUploadedFile.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        }
    }
})

export const { deleteFileReset } = DeleteUploadedFileSlice.actions;